import React from 'react';
import { ErrorMessage, useField } from 'formik';

import { EmailContainer, EmailInput, EmailInputWrapper, EmailLabel, EmailWrapper, SuEmailInput, SuEmailLabel } from './Email.style';

export interface Props {
  suOptinForm?: boolean;
  placeholderText?: string;
  labelHtml: string;
  name: string;
  disabled?: boolean;
}

export const Email: React.FunctionComponent<Props> = ({
  suOptinForm,
  placeholderText,
  labelHtml,
  name,
  disabled,
} : Props) => {
  const [field, meta] = useField(name);
  const isEmailInvalid = meta.error !== undefined && meta.touched;

  if (suOptinForm === true) {
    return (
      <EmailWrapper>
        <SuEmailLabel htmlFor="email">{ labelHtml }</SuEmailLabel>
        <EmailInputWrapper>
          <SuEmailInput id="email" type="email" value={placeholderText} disabled/>
        </EmailInputWrapper>
      </EmailWrapper>
    );
  }
  return (
    <EmailContainer>
      {isEmailInvalid
        ? <EmailLabel isEmailValid={false}><ErrorMessage name={name} /></EmailLabel>
        : <EmailLabel
          isEmailValid
          dangerouslySetInnerHTML={{ __html: labelHtml }}
        />
      }
      <EmailInput
        type="email"
        placeholder={placeholderText}
        isEmailValid={!isEmailInvalid}
        disabled={disabled}
        {...field}
      />
    </EmailContainer>
  );
};
